// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ProductListProductImage from "@bg/Overrides/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@bg/Overrides/Widgets/ProductList/ProductListProductInformation";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    infoWrapper?: InjectableCss;
    actionsWrapper?: InjectableCss;
    searchScoreDataGridItem?: InjectableCss;
}

export const productCardStyles: ProductListProductCardStyles = {
    searchScoreDataGridItem: {
        css: css`
            width: 100%;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            width: 100%;
        `,
    },
    imageWrapper: {
        css: css`
            width: 139px;
            margin-right: 20px;
        `,
    },
    infoWrapper: {
        css: css`
            flex: 1 1 auto;
        `,
    },
    actionsWrapper: {
        css: css`
            width: 250px;
            min-width: 250px;
            padding-left: 20px;
            border-left: 1px solid ${getColor("common.ui2")};
        `,
    },
};

const styles = productCardStyles;

const ProductListProductCard: FC<Props> = props => {
    return (
        <StyledWrapper
            {...styles.wrapper}
            data-test-selector={`productListProductCard${props.product.id}`}
            className="product-card"
        >
            <StyledWrapper {...styles.imageWrapper}>
                <ProductListProductImage
                    showImage={props.showImage}
                    showCompare={false}
                    showAddToList={false}
                    showImageBadge={props.showImageBadges}
                    showTextBadge={props.showTextBadges}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.infoWrapper}>
                <ProductListProductInformation
                    showAttributes={false}
                    showBrand={false}
                    showPartNumbers={props.showPartNumbers}
                    showTitle={props.showTitle}
                    showAvailability={props.showAvailability}
                    showImageBadges={props.showImageBadges}
                    maxImageBadges={props.maximumNumberOfImageBadges}
                    showTextBadges={props.showTextBadges}
                    maxTextBadges={props.maximumNumberOfTextBadges}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.actionsWrapper}>
                <ProductListActions
                    showAddToList={props.showAddToList}
                    showPrice={props.showPrice}
                    {...({ showAvailability: false, showCompare: props.showCompare } as any)}
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductCard);
